import * as React from "react";
const identityMapper = (key) => key;
const KeyMapperContext = React.createContext(identityMapper);
export default KeyMapperContext;
